/**
 * Returns `message` of `Error` or passes input to `String()`
 */
export const getErrorString = (e: unknown): string => {
  if (e instanceof Error) {
    return e.message;
  }
  return String(e);
};
